export default "__VITE_ASSET__76e9815c__"